import {
  DamageWaiverLineItem,
  FeeLineItem,
  PickupLineItem,
  SecurityDepositLineItem,
  TaxLineItem,
} from '../../../../clients/quipli-service/financials/financials';

import { Currency } from 'dinero.js';
import { DeliveryLineItem, FinancialSummary } from '../../../../clients/quipli-service/financials/financials';
import { Location } from '../../../../clients/quipli-service/location/location';
import Dinero from 'dinero.js';
import { Order } from '../../../../clients/quipli-service/order/order';

export const prepareUpdateOrderInputs = (summary: FinancialSummary, location: Location, order: Order) => {
  const cartTotal = summary.lineItems.reduce(
    (acc, line) => (line.type === 'Product' || line.type === 'CustomProduct' ? acc.add(line.amount) : acc),
    Dinero({ amount: 0, currency: location.currency as Currency }),
  );

  const orderDelivery = summary?.lineItems.find((line) => line.type === 'Delivery') as DeliveryLineItem;
  const delivery = orderDelivery
    ? orderDelivery.amount
    : summary?.lineItems.reduce(
        (acc, line) => (line.type === 'ProductDelivery' ? acc.add(line.amount) : acc),
        Dinero({ amount: 0, currency: location.currency as Currency }),
      );
  const orderPickup = summary?.lineItems.find((line) => line.type === 'Pickup') as PickupLineItem;
  const pickup = orderPickup
    ? orderPickup.amount
    : summary?.lineItems.reduce(
        (acc, line) => (line.type === 'ProductPickup' ? acc.add(line.amount) : acc),
        Dinero({ amount: 0, currency: location.currency as Currency }),
      );
  const damageWaiver = summary?.lineItems.find((line) => line.type === 'DamageWaiver') as DamageWaiverLineItem;
  const couponDiscount =
    summary?.lineItems.find((line) => line.type === 'TagPricing' || line.type === 'Coupon')?.amount ||
    Dinero({ amount: 0, currency: location.currency as Currency });
  const tax = summary?.lineItems.find((line) => line.type === 'Tax') as TaxLineItem;

  const locationFees = (summary?.lineItems.filter((line) => line.type === 'Fee') || []) as FeeLineItem[];
  const discount =
    summary?.lineItems.find((line) => line.type === 'AdditionalDiscount')?.amount ??
    Dinero({ amount: 0, currency: location.currency as Currency });

  const orderSecurityDeposit = summary?.lineItems.find((line) => line.type === 'SecurityDeposit') as
    | SecurityDepositLineItem
    | undefined;

  const securityDepositPrice = orderSecurityDeposit
    ? orderSecurityDeposit.amount
    : summary?.lineItems.reduce(
        (acc, line) => (line.type === 'ProductSecurityDeposit' ? acc.add(line.amount) : acc),
        Dinero({ amount: 0, currency: location.currency as Currency }),
      );

  const existingProductFees = order.products.flatMap((p) => p.additionalFees);

  return {
    cartTotal,
    orderDelivery,
    delivery,
    orderPickup,
    pickup,
    damageWaiver,
    couponDiscount,
    tax,
    locationFees,
    discount,
    orderSecurityDeposit,
    securityDepositPrice,
    existingProductFees,
  };
};
